/* Header */
const userMenuTxt = {
    'info': 'Mis datos',
    'account': 'Mi cuenta',
    'orders': 'Mis compras',
    'lists': 'Mis listas',
    'repeatOrder': 'Repetir última compra',
    'cards': 'Mis tarjetas',
    'logout': 'Cerrar Sesión',
    'frequentProducts': 'Mis productos frecuentes',
    'bank': 'Mi cuenta bancaria',
    'favoriteProducts': 'Mis favoritos',
    'prime': {
        'userPrime': 'Mi Jumbo Prime',
        'notPrime': 'Quiero ser'
    }
};

const deliverySelectorTxt = {
    'deliveryMode': 'Modo de entrega',
    'delivery': 'Llevamos tu compra a',
    'express': 'Llevamos tu compra a',
    'store': 'Retira tu compra en',
    'car': 'Retira tu compra en',
    'notSelected': 'Aún no has seleccionado modo de entrega',
    'change': 'Cambiar',
    'select': 'Seleccionar',
};

const loginRegisterTxt = {
    'login': 'Ingresa',
    'register': 'Regístrate'
};

/* User Account */
const menuAccountTxt = {
    'info': userMenuTxt.info,
    'orders': userMenuTxt.orders,
    'lists': userMenuTxt.lists,
    'cards': userMenuTxt.cards,
    'frequentProducts': userMenuTxt.frequentProducts,
    'bank': userMenuTxt.bank,
    'favoriteProducts': userMenuTxt.favoriteProducts,
    'prime': {
        'userPrime': userMenuTxt.prime.userPrime,
        'notPrime': userMenuTxt.prime.notPrime
    }
};

const accountInfoTxt = {
    'title': userMenuTxt.info,
};

const userDeliveryTxt = {
    'title': 'Mis direcciones',
    'btnSubmit': 'Agregar nueva dirección'
};

const userInfoTxt = {
    'title': 'Datos personales',
    'btnCancel': 'Cambiar clave',
    'btnSubmit': 'Cambiar datos',
};

const accountCardsTxt = {
    'title': userMenuTxt.orders,
    'filter': 'Filtrar',
    'btnSearch': 'Buscar'
};

const pastOrdersTxt = {
    'empty': 'Aún no tienes compras en Jumbo.cl',
    'subtitle': 'Navega por las categorías, realiza tus compras y aquí se guardarán',
    'btnSubmit': 'Comenzar a comprar',
    'viewMore': 'Ver más'
};

const accountListsTxt = {
    'title': userMenuTxt.lists,
    'empty': 'Aún no tienes listas con tus productos favoritos',
    'btnBuy': 'Comprar seleccionadas',
    'btnCreate': 'Crear nueva lista',
};

const accountCardListTxt = {
    'title': userMenuTxt.cards,
    'empty': 'Todavía no tienes listas creadas.',
    'btnBuy': 'Comprar seleccionadas',
    'btnCreate': 'Crear nueva lista',
};

const listItemTxt = {
    'btnBuy': 'Comprar',
    'btnSearch': 'Buscar productos',
    'btnRemove': 'Eliminar Lista',
    'btnEdit': 'Editar',
    'modifyList': 'Modificar'
};

const cartPageMessage = {
    'messageTitle': 'Si alguno de los productos no estuviera disponible al preparar tu pedido, te llamaremos para que nos indiques cómo te gustaría sustituirlo. ',
    'iconHover': 'En alta demanda algunos pedidos podrían ser preparados en la noche, por lo que no llamaremos ni sustituiremos productos',
};

/* Modals */
const modalRegisterTxt = {
    'title': 'Crea tu cuenta',
    'subtitle': 'Por favor, ingresa los siguientes datos:',
    'btnCancel': 'Volver',
    'btnSubmit': 'Siguiente',
    'message': 'Si ya estás registrado en Santaisabel.cl o Spid puedes ingresar con el mismo mail y clave'
};

const modalReschedule = {
    'title': 'Reprograma tu pedido',
    'subtitle': 'Por favor, ingresa los siguientes datos:',
    'btnCancel': 'Cancelar',
    'btnSubmit': 'Ver Pedido'
};

const drawerLoginRegisterTxt = {
    'login': 'Ingresa',
    'back': 'Volver'

}

const DrawerRegiterTxt = {
    'title': 'Crea tu cuenta',
    'btnCancel': 'Volver',
    'btnSubmit': 'Siguiente',
    'message': 'Para suscribirte a Jumbo Prime debes iniciar sesión o crear tu cuenta. Si ya estás registrado en Santaisabel.cl o Spid puedes ingresar con el mismo mail y clave'
}

const modalLoginTxt = {
    'title': 'Ingresa a tu cuenta',
    'subtitle': 'Por favor, ingresa los siguientes datos:',
    'btnCancel': loginRegisterTxt.register,
    'btnSubmit': loginRegisterTxt.login,
    'forgot': '¿Olvidaste tu clave?',
    'message': 'Si ya estás registrado en Santaisabel.cl  o Spid puedes ingresar con el mismo mail y clave'
};

const modalPasswordTxt = {
    'message': 'Recuerda que la actualización de tu clave aplicará también para tu cuenta de SantaIsabel.cl  y Spid'
};

const modalDeliverySelectorTxt = {
    'title': 'Selecciona un modo de entrega',
    'noCoverage': 'Tu dirección está fuera de la zona de cobertura o no hay disponibilidad de despacho, comunícate con Servicio al Cliente o elige otro modo de entrega.',
    'storeUnavailable': 'Este local no tiene horarios disponibles.',
    'noWindows': 'En este momento no tenemos horarios disponibles para esta dirección.',
    'tryLater': 'Por favor intenta más tarde.',
    'btnSubmit': 'Confirmar',
    'btnAdd': 'Agregar dirección'
};

const drawerLogin = {
    'title': 'Ingresa a tu cuenta',
    'btnCancel': drawerLoginRegisterTxt.back,
    'btnSubmit': drawerLoginRegisterTxt.login,
    'forgot': '¿Olvidaste tu clave?',
    'register': 'Regístrate',
    'message': 'Para suscribirte a Jumbo Prime debes iniciar sesión o crear tu cuenta. Si ya estás registrado en Santaisabel.cl o Spid puedes ingresar con el mismo mail y clave'
}



/* Checkout */
const dateDeliveryTxt = {
    'noWindows': modalDeliverySelectorTxt.noWindows,
    'tryLater': modalDeliverySelectorTxt.tryLater,
    'btnEdit': 'Selecciona uno diferente ó bien otro modo de entrega.',
    'storeUnavailable': modalDeliverySelectorTxt.storeUnavailable,
    'selectDate': 'No has seleccionado una fecha.',
    'selectTime': 'No has seleccionado una hora.',
    'calcFail': 'No pudimos calcular el tiempo de entrega.'
}


const contact = {
    'phone': '600 400 3000'
}

/* Footer */
const footerTxt = {
    'copyright': ' Copyright © 2019 Cencosud - Jumbo '
};

const newsLetterTxt = {
    'title': 'Suscríbete a nuestras ofertas y novedades',
    'successTitle': '¡Ya estás registrado/a!',
    'successSubtitle': 'Pronto enviaremos a tu mail ofertas especialmente seleccionadas para ti.',
    'btnSubmit': 'Suscribir'
};

const preFooterTxt = {
    'faq': {
        'title': 'Centro de Ayuda',
        'subtitle': 'Si tienes alguna duda ingresa aquí'
    },
    'stores': {
        'title': 'Nuestros Locales',
        'subtitle': 'Encuentra tu local más cercano'
    },
    'delivery': {
        'title': 'Estado del pedido',
        'subtitle': 'Conoce el estado de tu compra'
    },
    'reschedule': {
        'title': 'Reprograma tu pedido',
        'subtitle': 'Administra tus compras'
    },
    'order': {
        'title': 'Problemas con tu pedido',
        'subtitle': 'Resuelve dudas'
    },
    'tracking': {
        'title': 'Seguimiento de Compras',
        'subtitle': 'Seguimiento de tu despacho en línea'
    },
};

/*Modal terms && conditions*/
const termsConditionsText = {
    'title': 'Actualizamos nuestros Términos y Condiciones',
    'subTitle': 'Cobros reflejados en tu pedido',
    'firstParagraph': 'Al momento de realizar tu pedido, se realizará un cobro en la tarjeta de crédito o débito que seleccionaste, que corresponde al 90% del total de tu compra.',
    'secondParagraph': 'Una vez que tus productos hayan sido recolectados y pasados por caja, se emitirá una boleta en la cual se calculará y cobrará o devolverá la diferencia, de haberla, por los productos que serán efectivamente entregados.',
    'thirdParagraph': 'De esta forma, no se facturarán los artículos faltantes, pero sí se agregan al cobro, en caso de haberlos, aquellos productos que sumaste al pedido durante el llamado telefónico con el picker.',
    'fourParagraph': 'Para realizar transacciones en esta plataforma puedes utilizar medios de pago que hayas registrado previamente en nuestra página, registrar un medio de pago nuevo para facilitar futuras transacciones, o bien pagar tu transacción sin dejar registrados los datos de tu tarjeta.',
    'lastParagraph': '',
    'onlyParagraph' : false
}

/* Home & Landing Components*/
const sliderProductsTxt = {
    'viewMore': 'Ver más'
};

/* Breadcrumb */
const breacrumbTxt = {
    'home': 'Home'
};

const identificationCencoPrime = {
    cencoPrime: '<strong>¡Eres Jumbo Prime!</strong> Tus compras sobre $30.000 tienen despacho gratis.',
    cencoPrimeCat: '¡Eres Jumbo Prime! Tus compras sobre $30.000 con <strong>T. Cencosud Scotiabank</strong> tienen despacho gratis.',
    notCencoPrime: '<strong>Prueba sin costo Jumbo Prime.</strong> Disfruta de despacho gratis en todas tus compras sobre  $30.000.  <a class="new-link" href="/registrate-prime" target="_self">Quiero ser prime<a>'
}

export {
    modalRegisterTxt,
    modalLoginTxt,
    modalPasswordTxt,
    userDeliveryTxt,
    userInfoTxt,
    userMenuTxt,
    menuAccountTxt,
    deliverySelectorTxt,
    loginRegisterTxt,
    footerTxt,
    newsLetterTxt,
    preFooterTxt,
    sliderProductsTxt,
    breacrumbTxt,
    pastOrdersTxt,
    modalDeliverySelectorTxt,
    accountCardsTxt,
    accountListsTxt,
    listItemTxt,
    accountInfoTxt,
    dateDeliveryTxt,
    modalReschedule,
    accountCardListTxt,
    cartPageMessage,
    identificationCencoPrime,
    termsConditionsText,
    contact,
    drawerLogin,
    DrawerRegiterTxt
};
